import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import uid from 'utils/uid';
import { colors } from 'core/theme';
import { media } from 'core/layout';
import { Heading } from 'elements';

const StyledInfoBlock = styled.div`
  & + & {
    margin-left: 4em;
  }

  a {
    color: inherit;
    display: inline-block;
    text-decoration: none;

    &:hover {
      color: ${colors.text};
      text-decoration: underline;
    }
  }

  span {
    display: inline-block;
  }

  ${media.tablet`
    flex: 0 0 50%;
    margin-top: 0;

    & + & {
      margin-left: 0;
    }

    &:first-child {
      margin-bottom: 1.5em;
    }
  `};

  @media (max-width: 500px) {
    :first-child {
      margin-bottom: 0;
    }

    &:not(:first-child) {
      margin-top: 1em;
    }
  }
`;

const List = styled.ul`
  list-style: none;
  margin-top: 0.5em;
  margin-bottom: 0;
  padding-left: 0;

  display: flex;
  flex-direction: column;

  & > li {
    display: flex;
    justify-content: space-between;

    & > * {
      padding: 0.6em 0.5em 0.4em;
      transform: translateX(-0.5em);
    }
  }
`;

const InfoItemLink = ({label, link, target, a11yLabel}) => {
  let props = {
    href: link,
    target,
  };
  const external = (/^http|mailto|tel/).test(link);
  const LinkComponent = external ? 'a' : Link;
  let linkProps = external ? {
    href: link,
    target: target,
  } : {
      to: link,
    }
  if (a11yLabel) {
    linkProps = Object.assign({}, linkProps, {
      'aria-label': a11yLabel,
    });
  }
  return (
    <LinkComponent {...linkProps}>
      {label}
    </LinkComponent>
  );
}

const InfoItem = ({content, label, link, target, a11yLabel}) => {
  let children;

  if (content) {
    if (Array.isArray(content)) {
      children = content.map((c, i) => (
        <span key={i} dangerouslySetInnerHTML={{__html: c}} />
      ));
    } else {
      children = (
        <span dangerouslySetInnerHTML={{__html: content}} />
      );
    }
  } else {
    children = (
      <InfoItemLink label={label} link={link} target={target} a11yLabel={a11yLabel} />
    );
  }

  return (
    <li key={uid()}>
      {children}
    </li>
  );
};

const InfoBlock = ({title, items}) => {
  return (
    <StyledInfoBlock key={uid()}>
      <Heading level={6}>
        {title}
      </Heading>
      <List>
        {
          items.map(InfoItem)
        }
      </List>
    </StyledInfoBlock>
  );
};

export default InfoBlock;



// WEBPACK FOOTER //
// ./src/modules/Footer/components/InfoBlock.jsx